import React from "react";

export const SvgIconX = ({ color = "#8E929A", ...props }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			color={color}
			{...props}
		>
			<path
				d="M5 15L15 5M5 5L15 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
